import styled from "styled-components";
import { BREAKPOINT, COLORS, FONTS } from "../../../constants/Styles";

export const AdminPanelContainer = styled.div`
  margin-bottom: 1rem;
  background-color: ${COLORS.tableBackground};
  padding: 1rem;
  border-radius: 1rem;
`;

export const AdminPanelContents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AdminPanelTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: ${FONTS.spaceGrotesk};
  gap: 0.5rem;
`;

export const ConsignmentSearchContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 600px;

  @media (max-width: ${BREAKPOINT}) {
    width: 400px;

    flex-direction: column;
  }
`;
